'use client';

import { usePublicContent } from '@/lib/use-public-content';
import type { LegalContentFile } from '@/types/content';

export default function LegalContent({
    file,
    initialHtml,
}: {
    file: LegalContentFile;
    initialHtml: string;
}) {
    const { html } = usePublicContent(file, { html: initialHtml });

    return (
        <div
            className="legal-content h-full w-full container mx-auto max-lg:px-4 px-0 pb-20 pt-10 text-white"
            dangerouslySetInnerHTML={{ __html: html }}
        />
    );
}
